import { render, staticRenderFns } from "./RecebimentoXML.vue?vue&type=template&id=d21227dc&scoped=true"
import script from "./RecebimentoXML.vue?vue&type=script&lang=js"
export * from "./RecebimentoXML.vue?vue&type=script&lang=js"
import style0 from "./RecebimentoXML.vue?vue&type=style&index=0&id=d21227dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d21227dc",
  null
  
)

export default component.exports